export enum LangToggleType {
  Desktop,
  Mobile,
}
